import { AddressCardModel, SiteInfo, SponsorInfo, ProgramInfo, SiteAppInfo, FeatureFlagInfo } from "@/models";

export interface IOfflineInfo {
  FeatureFlagList: FeatureFlagInfo[];
  sites: SiteInfo[];
  sponsors: SponsorInfo[];
  programs: ProgramInfo[];
  siteAppDates: SiteAppInfo[];
  SiteAppNonCongregateMeals: SiteAppNonCongregateMeal[];
}

export interface ICounterState {
  selectedSponsor: AddressCardModel;
  selectedSponsorId: number;
  selectedSite: AddressCardModel;
  selectedSiteId: number;
  selectedMealDate: string;
  featureFlags: FeatureFlagInfo[];
  sites: SiteInfo[];
  sponsors: SponsorInfo[];
  programs: ProgramInfo[];
  selectedProgramId: string;
  siteAppDates: SiteAppInfo[];
  pwaInstalled: boolean;
  isOnline: boolean;
  isSyncing: boolean;
  timeStamp: number;
}

export class CounterState implements ICounterState {
  selectedSponsor: AddressCardModel = new AddressCardModel();
  selectedSponsorId: number = 0;
  selectedSite: AddressCardModel = new AddressCardModel();
  selectedSiteId: number = 0;
  selectedMealDate: string = '';
  featureFlags: FeatureFlagInfo[] = [];
  sites: SiteInfo[] = [];
  sponsors: SponsorInfo[] = [];
  programs: ProgramInfo[] = [];
  selectedProgramId: string = '';
  siteAppDates: SiteAppInfo[] = [];
  pwaInstalled: boolean = false;
  isOnline: boolean = navigator.onLine;
  isSyncing: boolean = false;
  timeStamp: number = 0;
}

export class SiteAppNonCongregateMeal {
      siteApplicationId = 0;
      siteId = 0;
      programYearId = 0;
      programId = '';
      nonCongregateMealApprovedInd = false;
      congregateExcessiveHeatApprovedInd = false;
      nonCongregateMealRequestInd = false;
      nonCongregateMealMultiDaysInd = false;
      nonCongregateMealSunInd = false;
      nonCongregateMealMonInd = false;
      nonCongregateMealTueInd = false;
      nonCongregateMealWedInd = false;
      nonCongregateMealThuInd = false;
      nonCongregateMealFriInd = false;
      nonCongregateMealSatInd = false;
      nonCongregateMealDayQty = 0;
      nonCongregateBulkMealBRK = false;
      nonCongregateBulkMealAMS = false;
      nonCongregateBulkMealLUN = false;
      nonCongregateBulkMealPMS = false;
      nonCongregateBulkMealSUP = false;
      nonCongregateBulkMealNA = false;
      nonCongregateExcessiveHeatWaiverRequestInd = false;
}